module.exports = __webpack_public_path__ + "static/media/ash-wilson-design.98066293.png";